import "vuetify/styles";
import { createVuetify } from "vuetify";
import { fa } from "vuetify/locale";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader

const defaultLightTheme = {
  dark: false,
  colors: {
    background: "#FFFFFF",
    surface: "#FFFFFF",
    primary: "#183462",
    secondary: "#0073ef",
    error: "#FF3D32",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#E8B151",
    "blue-dark": "#465d81",
  },
};

const vuetify = createVuetify({
  components,
  directives,
  display: {
    mobileBreakpoint: "md",
    thresholds: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1264,
      xl: 1904,
    },
  },
  locale: {
    locale: "fa",
    fallback: "fa",
    messages: { fa },
    rtl: { fa: true },
  },
  theme: {
    defaultTheme: "defaultLightTheme",
    themes: {
      defaultLightTheme,
    },
  },
});

export default vuetify;
